/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UpgradeSummary { 
    /**
     * Number of entities failed to submit upgrade task.
     */
    failed_submission: number;
    /**
     * Number of entities successfully submitted upgrade task.
     */
    successful_submission: number;
    /**
     * Total number of entities received for upgrade.
     */
    total: number;
}

